import api from '../../services/api';

const baseUrl = 'crm/agenda'

const findSellerAgendaWithFilter = async (sellerId, filters, pagination) =>
    api.post({ service: `${baseUrl}/${sellerId}`, data: { filters, pagination } });

const findOrbitaConnection = async () =>
    api.get({ service: `${baseUrl}/orbita-connection`, silent: true });

export default {
    findSellerAgendaWithFilter,
    findOrbitaConnection
}